import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {CouponType, CouponTypeObject, stampa_id} from "./SanPellegrino";
import {getDateYear} from "../../Utility/DateUtility";
import {Permission} from "../../../app/Login/_guards/Permission";


function campoCustom(nome: string, valore:((coupon,parent?)=>string )| string) {
  return {
    nome: nome, oggetti: ["prezzo"], type: 'html', func: (coupon, parent?) => [typeof valore == "string" ? valore : valore(coupon,parent)]
  }
}



export function ReportCoupon(): OggettoConfig {
  var OBJ: OggettoConfig = {
    Id: "report",
    fullListRoute: "/prodotti/list",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 50},
    ListResponseHasData:true,
    MenuItems: [
      {
        path: "/shared/dynamiclist/report",
        title: "Report",
        icon: "fa-solid fa-list",
        class: "",
        capacita: [],
        ruoliOperativi:["S","NAM", "DM", "SA"]
      },
    ],
    Filters:[
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "col-lg-3", ),
      CampoAggiuntivo.SingleDropdown("Stato ordine", "stato",[
        {id: "SDA", label: "Da assegnare"},
        {id: "SA", label: "Assegnati"},
        {id: "SAA", label: "Assegnati ad Agente"},
        {id: "SPV", label: "Assegnati al PV"},
        {id: "SBS", label: "Bonifico Segnalato"},
        {id: "SPA", label: "Pagato"},
        {id: "SSP", label: "Spedito"},
      ],"label", {}, 'col-lg-3'),
      CampoAggiuntivo.InputField("Cliente (PV)", "cliente", "text", "col-lg-3", ),
      CampoAggiuntivo.SingleDropdown(
        "Manager",
        "manager",
        "/anagrafica/profilo/cliente",
        "fullName",
        {
          parameter: [],
          responseHasData: false,
          responseMap(profilo){
            return profilo.referenti?.filter(x=>x.ruoliAccessoObject.find(y=>y.id == 24 || y.id == 25))
          }
        },
        'col-lg-3',
        (x,y:Permission)=> y.isOperativeRoles(['S'])
      ),

    ],
    Headers: [
      campoCustom("Lotto",(coupon) =>getDateYear(coupon.dataScadenza1)?.toString()),
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "", {modificabile: false}),
      campoCustom("Stato", (coupon) =>  {
        if(coupon.statoCoupon)//spedito)
          return coupon.statoCoupon;
        if(false)//pagato)
          return "Pagato";
        if(false)//bonifico segnalato)
          return "Bonifico Segnalato";
        if(coupon.cliente || coupon.video)
          return "Assegnato a PV";
        if(coupon.agenteCoupon)
          return "Assegnato ad Agente";
        if(coupon.dmCoupon)
          return "Assegnato a DM";
        if( coupon.namCoupon)
          return "Assegnato al NAM"
        return "DA ASSEGNARE";
      }),
      campoCustom("Prodotto", (coupon)=>coupon.correlatiObject?.reduce((a,c)=>`${a} ${c.prodotto}`,'')),
      campoCustom("Tipo Coupon", (coupon) =>CouponTypeObject(coupon).label),
      campoCustom("Cliente (PV)", (coupon) => coupon.clienteObject?.nominativo ?? coupon.video ?? ""),
      campoCustom("Email", (movimentazione) => movimentazione.video ),
      campoCustom("Agente", (coupon) => coupon.agenteCoupon?.fullName ?? ""),
      campoCustom("Manager", (coupon) => coupon.dmCoupon?.fullName ?? coupon.namCoupon?.fullName ?? ""),
      campoCustom("Danneggiato", (coupon)=>coupon.danneggiato ),
      campoCustom("Sostituito", (coupon)=>coupon.sostituito )


    ],
    DisableEdit: false,
    AzioniLista: [

    ]
  }


  return OBJ;
}


